module.exports = __webpack_public_path__ + "static/media/7.0dbbd4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/beards/7.png
// module id = 1191
// module chunks = 0